import '../../../../assets/img/flag-by.png';
import '../../../../assets/img/flag-de.png';
import '../../../../assets/img/flag-tr.png';
import '../../../../assets/img/flag-ua.png';

import { Transition } from '@uirouter/core';
import { IFormController, IWindowService } from 'angular';
import { Action } from '../../../common/actions/core/action';
import ActionDispatcherService from '../../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../../common/actions/core/action-handler';
import { LoginAttemptRejection } from '../../../common/services/auth/auth.model';
import AuthService from '../../../common/services/auth/auth.service';
import SecuredStorage from '../../../common/services/local-storage/secured-storage.service';
import GlobalSpinnerService from '../../../common/services/spinner/global-spinner.service';
import { UserResponse } from '../../../common/services/user/user.model';
import UserService from '../../../common/services/user/user.service';
import UtilService from '../../../common/services/util.service';
import { MobileConnectResponse } from '../../mobile-connect/mobile-connect.model';
import {
  CloseLoginDialogAction,
  McRequestedAction,
  OpenLoginDialogAction,
  ResetLoginFormAction
} from '../login-dialog.action';

const storageKey = 'user-phonenumber';
const codeKey = 'user-phonecode';

/* @ngInject */
export default class LoginBoxMcController implements ActionHandler {
  public loginPhoneCode;
  public phoneNumber: string;
  public msisdn: string;
  public rememberMe: boolean;
  public error: string;
  public phoneCodes;
  public dropDownState: boolean;
  public mcRequested: boolean;
  public onReset: any;

  private mobileConnectForm: IFormController;
  private afterLoginMessages: string[];
  private transition: Transition;

  constructor(
    public config,
    private authService: AuthService,
    private $element,
    private $scope,
    private $state,
    private i18n,
    private actionDispatcher: ActionDispatcherService,
    private securedStorage: SecuredStorage,
    private userService: UserService,
    private globalSpinner: GlobalSpinnerService
  ) {}

  public $onInit() {
    this.phoneCodes = this.config.countries;
    this.loginPhoneCode =
      this.securedStorage.get(codeKey) ||
      this.resolvePhoneCode(this.userService.getTerritory());

    this.phoneNumber = this.securedStorage.get(storageKey);
    this.rememberMe = !!this.phoneNumber;
  }

  public chooseCode(code) {
    this.loginPhoneCode = code;
    this.dropDownState = false;
  }

  public showDropDown() {
    this.dropDownState = !this.dropDownState;
  }

  public $postLink() {
    angular.element(() => {
      this.mobileConnectForm = this.$scope.mobileConnectForm;
      this.actionDispatcher.register(this);
    });
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
  }

  public handle(action: Action) {
    if (action instanceof OpenLoginDialogAction) {
      this.transition = action.transition;
    }

    if (action instanceof ResetLoginFormAction) {
      this.resetForm();
    }
  }

  public login() {
    // this.resetError();
    this.msisdn = `${this.loginPhoneCode.value}${this.phoneNumber}`;
    this.mcRequested = true;
    this.onMcRequestChange();
  }

  public resetForm() {
    this.onReset();
    this.reset();
  }

  public onMcSucceeded(mc: MobileConnectResponse) {
    this.globalSpinner.start();
    this.mcRequested = false;
    this.onMcRequestChange();
    this.rememberUser();

    UtilService.applyIfNeeded(this.$scope);

    this.authService
      .mcLogin(
        `${this.loginPhoneCode.value}${this.phoneNumber}`,
        mc.code,
        mc.state
      )
      .then((user: UserResponse) => {
        this.userService.resetCache();
        this.userService.setTerritory(this.loginPhoneCode.territoryCode);
        this.actionDispatcher.dispatch(new CloseLoginDialogAction());
        this.goToTargetState();
      })
      .catch((loginAttemptRejection: LoginAttemptRejection) => {
        this.onLoginError(loginAttemptRejection);
      })
      .finally(() => {
        this.globalSpinner.stop();
      });
  }

  public onMcFailed(mc: MobileConnectResponse) {
    this.mcRequested = false;
    this.onMcRequestChange();

    if (mc.error === 'USER_DID_NOT_APPROVE') {
      this.error = this.i18n.getTranslation(
        'login.error.mobileconnect.userDidNotApprove'
      );
    } else {
      this.error = this.i18n.getTranslation('login.error.mobileconnect.text');
    }
    UtilService.applyIfNeeded(this.$scope);
  }

  private onMcRequestChange() {
    this.actionDispatcher.dispatch(new McRequestedAction(this.mcRequested));
  }

  private reset() {
    this.phoneNumber = null;
    this.resetError();
  }

  private resetError() {
    this.error = null;
    this.mobileConnectForm.$setPristine();
    this.mobileConnectForm.$setUntouched();
  }

  private onLoginError(loginAttemptRejection: LoginAttemptRejection) {
    this.error = this.i18n.getTranslation('login.error.mobileconnect.text');
  }

  private rememberUser() {
    if (this.rememberMe) {
      this.securedStorage.set(codeKey, this.loginPhoneCode);
      this.securedStorage.set(storageKey, this.phoneNumber);
    } else {
      this.securedStorage.remove(codeKey);
      this.securedStorage.remove(storageKey);
    }
  }

  private goToTargetState(): void {
    if (this.transition) {
      this.$state.go(
        this.transition.targetState().name(),
        this.transition.targetState().params()
      );
    } else if ('login' === this.$state.current.name) {
      this.$state.go('myAccount');
    }
  }

  private resolvePhoneCode(territory: string) {
    let targetPhoneCode;
    if (territory) {
      targetPhoneCode = this.phoneCodes.filter(
        phoneCode =>
          phoneCode.territory.toLowerCase() === territory.toLowerCase()
      )[0];
    }

    return targetPhoneCode || this.phoneCodes[0];
  }
}



// WEBPACK FOOTER //
// ./src/app/components/login-dialog/login-box-mc/login-box-mc.controller.ts